module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-cols-1 h-full"
  }, [(_vm.audio_is_active && _vm.joining_audio) ? _c('div', [_c('div', {
    key: "loading",
    staticClass: "flex center-xs middle-xs h-inherit"
  }, [_c('p', [_vm._v("Connecting ....")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)])]) : (_vm.audio_is_active && !_vm.joinedAudioDiscussion) ? _c('div', [_c('div', {
    staticClass: "flex flex-col w-2/4 items-center justify-center mx-auto"
  }, [_c('div', {
    staticClass: "mb-5 text-lg font-bold"
  }, [_vm._v("Choose video and audio options")]), _vm._v(" "), (_vm.show_avatar) ? _c('div', [_c('img', {
    staticClass: "w-20 h-20 rounded-full object-cover",
    attrs: {
      "src": _vm.getProfile.avatar_url
    }
  })]) : _c('video', {
    ref: "camera",
    staticClass: "local-camera",
    attrs: {
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight,
      "autoplay": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-10 flex items-center w-full"
  }, [_vm._m(0), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.audioDevices,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "preserve-search": true,
      "show-labels": false,
      "placeholder": "Select microphone",
      "label": "label",
      "track-by": "deviceId",
      "limit": 1,
      "preselect-first": false,
      "limitText": function (count) { return ("and " + count + " more"); }
    },
    model: {
      value: (_vm.preferredAudioDevice),
      callback: function($$v) {
        _vm.preferredAudioDevice = $$v
      },
      expression: "preferredAudioDevice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2.5 flex items-center w-full"
  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.videoDevices,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "preserve-search": true,
      "show-labels": false,
      "placeholder": "Select camera",
      "label": "label",
      "track-by": "deviceId",
      "limit": 1,
      "preselect-first": false,
      "limitText": function (count) { return ("and " + count + " more"); }
    },
    model: {
      value: (_vm.preferredVideoDevice),
      callback: function($$v) {
        _vm.preferredVideoDevice = $$v
      },
      expression: "preferredVideoDevice"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "my-5 rounded bg-primary font-semibold text-white h-9 w-full disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.joinDiscussion
    }
  }, [_vm._v("\n        Join RoundTable\n      ")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-10"
  }, [_c('i', {
    staticClass: "fa-solid fa-microphone text-2xl"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-10"
  }, [_c('i', {
    staticClass: "fa-solid fa-video text-2xl"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-07b92148!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/discussionCircleMessages.vue
// module id = 1782
// module chunks = 61